var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_13584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.916992 0.916626C1.92533 0.916626 2.84199 1.74163 2.93366 2.74996L4.21699 14.2083C4.40033 16.0416 5.95866 17.5083 7.88366 17.5083H17.417",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11621 4.58337H19.4329C20.3495 4.58337 21.0829 5.31671 21.0829 6.23337C21.0829 6.32504 21.0829 6.50837 21.0829 6.60004L19.9829 11C19.5245 12.65 18.0579 13.75 16.4079 13.75H4.21621",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4163 21.0833C18.4289 21.0833 19.2497 20.2625 19.2497 19.25C19.2497 18.2374 18.4289 17.4166 17.4163 17.4166C16.4038 17.4166 15.583 18.2374 15.583 19.25C15.583 20.2625 16.4038 21.0833 17.4163 21.0833Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25033 21.0833C9.26285 21.0833 10.0837 20.2625 10.0837 19.25C10.0837 18.2374 9.26285 17.4166 8.25033 17.4166C7.2378 17.4166 6.41699 18.2374 6.41699 19.25C6.41699 20.2625 7.2378 21.0833 8.25033 21.0833Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_13584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.2fd26ce3dd524577c1bb7e7cb3e55895.svg";
export { ForwardRef as ReactComponent };